import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Col, Card, Table } from "react-bootstrap";

import { FaUserLarge } from "react-icons/fa6";

import { getInsituteverifyByID } from "../../../services/adminApiService/insituteVerficationApi/InsituteVerficationApiService";
import { useParams } from "react-router-dom";

import RemarkModal from "../Individual/RemarkModal";
import CleardCard from "../Individual/CleardCard";
import {
  formatLable,
  formatStatus,
  getStatusColor,
} from "../../../utils/colorAsperStatus";
import NotCleardOrganisation from "./NotCleardOrganisation";
import { clearInsituteVerfication } from "../../../services/adminApiService/organisationApi/OrganisationApiService";
import doc from "../../../images/google-docs.png";
import imgPdf from "../../../images/pdf.png";
import {
  getCityFromId,
  getCountryFromId,
  getStateFromId,
} from "../../../utils/CountryConveter";
import { getCorrectionByID } from "../../../services/adminApiService/admincorrectionApi/adminCorrectionApi";
import { doclabelMap } from "./DocLable";

const OrganizationVerficationForm = ({ roletype }) => {
  const { id } = useParams();
  const [remarkshowModal, setRemarkshowModal] = useState(false);
  const [showremarkrCard, setshowremarkCard] = useState(true);
  const [verficationList, setVerficationList] = useState({});
  const [insituteVerifyList, setInsituteVerifyList] = useState([]);
  const [correctionData, setCorrectionData] = useState([]);
  const [remarkdata, setRemarkdata] = useState("");
  const [currentRemarkId, setCurrentRemarkId] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchVerificationList = async () => {
      setLoading(true);
      try {
        const response = await getInsituteverifyByID(id);
        setVerficationList(response?.data?.data);
      } catch (error) {
        console.error("Error fetching verification list:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchVerificationList();
  }, [id]);

  const isValidUrl = (string) => {
    try {
      new URL(string);
      return true;
    } catch (_) {
      return false;
    }
  };

  const fetchCountryName = async () => {
    const storedRemarks =
      JSON.parse(localStorage.getItem(`verify_doc_remarks`)) || {};
    if (Object.keys(verficationList).length > 0) {
      const countryName = await getCountryFromId(verficationList.country);
      const stateName = await getStateFromId(
        verficationList.country,
        verficationList.state
      );
      const cityName = await getCityFromId(
        verficationList.state,
        verficationList?.city
      );
      const baseList = [
        { id: 1, label: "Institution Name", value: verficationList?.name_of_organization, key: "name_of_legel_entity", remarkFeilds: "insitutename", isError: !!storedRemarks[1], action: false, remark: storedRemarks[1] || "" },
        { id: 2, label: "Date of Establishment", value: verficationList?.year_of_operation, key: "Date_of_establish", remarkFeilds: "date_of_establish", isError: !!storedRemarks[2], action: false, remark: storedRemarks[2] || "" },
        { id: 3, label: "Type of Sports Institution", value: verficationList?.type_of_sports_institution, key: "type_of_sports_institution", remarkFeilds: "type_of_sports_institution", isError: !!storedRemarks[3], action: false, remark: storedRemarks[3] || "" },
        { id: 4, label: "District/City", value: verficationList?.city_name, key: "city", remarkFeilds: "district", isError: !!storedRemarks[4], action: false, remark: storedRemarks[4] || "" },
        { id: 5, label: "Pincode", value: verficationList?.pincode, key: "Zip_Code", remarkFeilds: "zip_Code", isError: !!storedRemarks[5], action: false, remark: storedRemarks[5] || "" },
        { id: 6, label: "Registered Address", value: verficationList?.address, key: "insituteAddress", remarkFeilds: "insituteAddress", isError: !!storedRemarks[6], action: false, remark: storedRemarks[6] || "" },
        { id: 7, label: "Official Website", value: verficationList?.website, key: "website", remarkFeilds: "Website", isError: !!storedRemarks[7], action: false, remark: storedRemarks[7] || "" },
        { id: 8, label: "Contact Person Name", value: verficationList?.contact_person_name, key: "contact_person_name", remarkFeilds: "contact_person_name", isError: !!storedRemarks[8], action: false, remark: storedRemarks[8] || "" },
        { id: 9, label: "Contact Person Designation", value: verficationList?.contact_person_designation, key: "contact_person_designation", remarkFeilds: "contact_person_designation", isError: !!storedRemarks[9], action: false, remark: storedRemarks[9] || "" },
        { id: 10, label: "Contact Person Mobile Number", value: verficationList?.contact_person_contact, key: "contact_person_contact", remarkFeilds: "contact_person_phone", isError: !!storedRemarks[10], action: false, remark: storedRemarks[10] || "" },
        { id: 11, label: "Contact Person Email", value: verficationList?.contact_person_email, key: "contact_person_email", remarkFeilds: "contact_person_email", isError: !!storedRemarks[11], action: false, remark: storedRemarks[11] || "" },
        { id: 12, label: "Sports Offered", value: verficationList?.sports_offered, key: "sports_offered", remarkFeilds: "sports_offered", isError: !!storedRemarks[12], action: false, remark: storedRemarks[12] || "" },
        { id: 13, label: "Facilities Available", value: verficationList?.facilities, key: "facilities", remarkFeilds: "aminities", isError: !!storedRemarks[13], action: false, remark: storedRemarks[13] || "" },
        { id: 14, label: "Achievements", value: verficationList?.achievements, key: "achievements", remarkFeilds: "achievements", isError: !!storedRemarks[14], action: false, remark: storedRemarks[14] || "" },
        { id: 15, label: "Affiliated Sports Bodies/Organizations", value: verficationList?.affiliated_sport_body, key: "affiliated_sport_body", remarkFeilds: "affiliated_sport_body", isError: !!storedRemarks[15], action: false, remark: storedRemarks[15] || "" },
        { id: 16, label: "Facilities Available", value: verficationList?.amenities_offered, key: "amenities_offered", remarkFeilds: "aminities", isError: !!storedRemarks[16], action: false, remark: storedRemarks[16] || "" },
        // { id: 17, label: "Other Amenities", value: verficationList?.other_amenities, key: "other_amenities", isError: !!storedRemarks[17], action: false, remark: storedRemarks[17] || "" },
      ];

      if (
        verficationList.registration_docs &&
        Array.isArray(verficationList.registration_docs)
      ) {
        verficationList.registration_docs.forEach((doc, index) => {
          const mappedLabel = doclabelMap[doc.doc_name] || doc.doc_name;
          
          baseList.push({
            id: 17 + index, // Continue IDs sequentially
            label: mappedLabel,
            value: doc.doc_file,
            remarkFeilds: doc.doc_name, // Assuming you want to display the file or use doc_name
            key: `registration_doc_${index + 1}`,
            action: false,
            remark: storedRemarks[17 + index] || "",
            isError: !!storedRemarks[17 + index],
            docType: doc.doc_type
          });
        });
      }

      setInsituteVerifyList(baseList);
    }
  };

  useEffect(() => {
    fetchCountryName();
  }, [verficationList]);

  const handleRadioChange = (id) => {
    setCurrentRemarkId(id);
    setRemarkshowModal(true);
    // setshowremarkCard(false);
    // isError(true)

    // insituteVerifyList.map((data) => {
    //   if (id == data.id) {
    //     data.isError = true;
    //   }
    // });
  };

  const handleRadiogreenChange = (id) => {
    const storedRemarks =
      JSON.parse(localStorage.getItem("verify_doc_remarks")) || {};
    delete storedRemarks[id];
    localStorage.setItem("verify_doc_remarks", JSON.stringify(storedRemarks));

    fetchCountryName();

    setCurrentRemarkId(id);

    const dataAfterr =
      JSON.parse(localStorage.getItem("verify_doc_remarks")) || {};
    const isEmpty = Object.keys(storedRemarks).length === 0;
    if (isEmpty) {
      setshowremarkCard(true);
    }

    insituteVerifyList.map((data) => {
      if (id == data.id) {
        data.isError = false;
      }
    });

    // fetchCountryName();
  };

  const updateRemark = (remark) => {
    const updatedList = insituteVerifyList.map((item) => {
      // console.log("updatedList",updatedList);
      if (item.id === currentRemarkId) {
        return { ...item, remark };
      }
      return item;
    });

    setInsituteVerifyList(updatedList);

    const storedRemarks =
      JSON.parse(localStorage.getItem(`verify_doc_remarks`)) || {};
    storedRemarks[currentRemarkId] = remark;
    localStorage.setItem(`verify_doc_remarks`, JSON.stringify(storedRemarks));
  };

  const profileImage = insituteVerifyList.find(
    (item) => item.label === "Institution Logo"
  );


  useEffect(() => {
    const storedRemarks =
      JSON.parse(localStorage.getItem("verify_doc_remarks")) || {};
    const isEmpty = Object.keys(storedRemarks).length === 0;

    if (isEmpty) {
      setshowremarkCard(true);
    } else {
      setshowremarkCard(false);
    }
  }, [insituteVerifyList]);

  const getCorrectionList = async (roletype, id) => {
    try {
      const response = await getCorrectionByID(roletype, id);
      const correctionData = response?.data?.data;

      if (correctionData && correctionData.registration_correction) {
        const storedRemarks =
          JSON.parse(localStorage.getItem("verify_doc_remarks")) || {};
        console.log("storedRemarks", storedRemarks);
        correctionData.registration_correction.forEach((correction, index) => {
          if (correction.remark) {
            storedRemarks[correction.id] = correction.remark;
          }
        });

        localStorage.setItem(
          "verify_doc_remarks",
          JSON.stringify(storedRemarks)
        );
        setInsituteVerifyList((prevList) =>
          prevList.map((item) =>
            item.id === id ? { ...item, remarks: storedRemarks } : item
          )
        );
      }

      setCorrectionData(correctionData);
    } catch (error) {
      console.error("Error fetching verification list:", error);
    }
  };

  useEffect(() => {
    getCorrectionList(roletype, id);
  }, [id]);

  return (
    <>
      <div className="row  px-3">
        <Col lg={12} className="mb-3">
          <Card style={{ height: "auto" }}>
            <div className="d-lg-flex justify-content-between p-2">
              <div className="mt-2">
                <div className="d-flex mt-1">
                  <div className="mx-2">
                    <h4><FaUserLarge className="text-primary" /></h4>
                    
                  </div>
                  <div className="mx-lg-2 d-flex">
                    <div><h4>Name Of Organisation :</h4></div>
                    <div className="mx-lg-1"><h4>{verficationList?.name_of_organization}</h4></div>
                  </div>
                </div>
              </div>
              <div>
                <div className="mx-2">
                  <strong>User Type</strong>
                </div>
                <Button className="bg-primary py-1">
                  {verficationList?.category_name}
                </Button>
              </div>
            </div>
          </Card>
        </Col>

        <Col lg={12} className="mb-3">
          <Card style={{ height: "auto" }}>
            <div className="d-lg-flex justify-content-between p-2">
              <div className="mt-2">
                <h4>
                  <span className="mx-lg-2 text-danger">
                    Current Status:{" "}
                    <span
                      style={{ color: getStatusColor(verficationList?.status) }}
                    >
                      {verficationList?.status &&
                        formatStatus(verficationList?.status)}
                    </span>
                  </span>
                </h4>
              </div>

              <div className="count_wrap" style={{ lineHeight: "0px" }}>
                <div>
                  <h4>Attempt Count</h4>
                </div>
                <div className="text-center count_title">
                  <strong> {verficationList?.attempt_count + 1}</strong>
                </div>
              </div>
            </div>
          </Card>
        </Col>
      </div>
      <div className="row px-3">
        <Col lg={12} className="mb-3">
          {profileImage && profileImage.value && (
            <Card style={{ height: "35vh" }}>
              <Card.Header>
                <Card.Title className="text-danger">VERIFY PHOTO</Card.Title>
              </Card.Header>
              <Card.Body>
                <Table responsive>
                  <thead>
                    <tr>
                      <th>SN</th>
                      <th style={{ maxWidth: "200px", height: "auto" }}>Institution Logo</th>
                      <th>Action</th>
                      <th style={{ width: "350px" }}>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th>1</th>
                      <td>
                        <img
                          src={profileImage.value}
                          alt="Profile"
                          style={{ width: "40px", height: "40px" }}
                        />
                        <a
                          href={profileImage.value}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text_view mx-1"
                        >
                          View file
                        </a>
                      </td>
                      <td>
                        <div className="d-flex">
                          <div className="form-check">
                            <input
                              className="form-check-input bg-success"
                              type="radio"
                              name={`gridRadios-${profileImage.id}`}
                              value="option1"
                              checked={!profileImage.isError}
                              onChange={() => handleRadiogreenChange(profileImage.id)}
                            />
                          </div>
                          <div className="form-check mx-2">
                            <input
                              className="form-check-input bg-danger"
                              type="radio"
                              name={`gridRadios-${profileImage.id}`}
                              value="option1"
                              checked={profileImage.isError}
                              onClick={() => handleRadioChange(profileImage.id)}
                            />
                          </div>
                        </div>
                      </td>
                      <td className="remarks-column">{profileImage.remark}</td>
                    </tr>
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          )}


          <Card className="mb-3" style={{ height: "auto" }}>
            <Card.Header>
              <Card.Title className="text-danger">
                VERIFY FORM FIELDS & DOCUMENTS
              </Card.Title>
            </Card.Header>
            <Card.Body>
              <Table responsive>
                <thead>
                  <tr>
                    <th>SN</th>
                    <th style={{ maxWidth: "200px", height: "auto" }}>Form Fields</th>
                    <th>Action</th>
                    <th style={{ width: "200px" }}>Remarks</th>
                  </tr>
                </thead>
                {loading ? (
                  <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <tbody>
                    {insituteVerifyList
                      .filter((data) => data.value)
                      .map((data, index) => {
                        return (
                          <>
                          
                            {data.label === "Institution Logo" ? (
                              " "
                            ) : (
                              <tr key={data.id}>
                                <td>{index + 1}</td>
                                <td style={{ maxWidth: "200px", height: "auto" }}>
                                  <span style={{ color: "#886CC0" }}>
                                    <strong>{formatLable(data?.label)}</strong>
                                  </span>
                                  <br />
                                  {isValidUrl(data.value) && data.label !== "Official Website" ? (
                                    <div>
                                      {data.value.includes(".pdf") ? (
                                        <img
                                          src={imgPdf}
                                          alt={data.label}
                                          style={{ maxWidth: "100px", height: "auto" }}
                                        />
                                      ) : data.value.includes(".doc") ? (
                                        <img
                                          src={doc}
                                          alt={data.label}
                                          style={{ maxWidth: "100px", height: "auto" }}
                                        />
                                      ) : (
                                        <img
                                          src={data.value}
                                          alt={data.label}
                                          style={{ maxWidth: "100px", height: "auto" }}
                                        />
                                      )}
                                      <a
                                        href={data.value}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text_view mx-1"
                                      >
                                        View file
                                      </a>
                                      <span style={{ marginLeft: "8px", fontSize: "13px" }}>
                                        {data?.docType ? `(${data?.docType})` : null}
                                      </span>
                                    </div>
                                  ) : isValidUrl(data.value) ? (
                                    <a
                                      href={data.value}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text_view"
                                    >
                                      {data.value}
                                    </a>
                                  ) : (
                                    <span style={{ fontSize: "13px" }}>
                                      {data.key === "amenities_offered"
                                        ? data.value
                                          .split(",")
                                          .map((item) => item.trim())
                                          .filter((item) => item !== "Others")
                                          .join(", ")
                                        : data.value}
                                    </span>
                                  )}
                                </td>



                                <td>
                                  <div className="d-flex">
                                    <div className="form-check">
                                      <input
                                        className="form-check-input bg-success"
                                        type="radio"
                                        name={`gridRadios-${data.id}`}
                                        value="option1"
                                        checked={!data.isError}
                                        onChange={() =>
                                          handleRadiogreenChange(data?.id)
                                        }
                                      />
                                    </div>
                                    <div className="form-check mx-2">
                                      <input
                                        className="form-check-input bg-danger"
                                        type="radio"
                                        name={`gridRadios-${data.id}`}
                                        value="option1"
                                        checked={data.isError}
                                        onClick={(event) =>
                                          handleRadioChange(data?.id)
                                        }
                                      />
                                    </div>
                                  </div>
                                </td>
                                <td className="remarks-column">{data.remark}</td>
                              </tr>
                            )}
                          </>
                        );
                      })}
                  </tbody>
                )}
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </div>

      <RemarkModal
        remarkshowModal={remarkshowModal}
        setRemarkshowModal={setRemarkshowModal}
        setRemarkdata={setRemarkdata}
        setVerficationList={setVerficationList}
        remarkdata={remarkdata}
        currentRemarkId={currentRemarkId}
        updateRemark={updateRemark}
        setshowremarkCard={setshowremarkCard}
        insituteVerifyList={insituteVerifyList}
        setInsituteVerifyList={setInsituteVerifyList}

      />

      {["final_submit", "pass_by_dso", "pass_by_admin_checker"].includes(verficationList?.status) ? (
        showremarkrCard ? (
          <CleardCard userType="2" clerVerifyApi={clearInsituteVerfication} />
        ) : (
          <NotCleardOrganisation
            insituteVerifyList={insituteVerifyList}
            userType="2"
          />
        )
      ) : verficationList?.status === "ongoing" ? (
        <Card className="text-center p-3">
          <h3 className="text-danger">
            It seems that Institution has not started further registration
            Process!
          </h3>
        </Card>
      ) : verficationList?.status === "ask_for_resubmit" ? (
        <Card className="text-center p-3">
          <h4>
            <span className="text-danger">Note: </span>
            The Application is sent back to the User for corrections. Once the
            User corrects information's asked, we can do further verification.
          </h4>
        </Card>
      ) : (
        null
      )}
    </>
  );
};

export default OrganizationVerficationForm;
